module.exports = __webpack_public_path__ + "images/west_berkshire_footer_logo.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/public/images/west_berkshire_footer_logo.jpg
// module id = 1371
// module chunks = 0